import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import API from './api/index'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
import Mock from './mock'
Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(API);

//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  //NProgress.start();
  //if (to.path == '/login') {
    //sessionStorage.removeItem('token');
 // }
  // else if (to.path == '/passwd') {
  //   next()
  // }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user) {
    if(to.path == '/passwd'){
      next()
    } else if( to.path == '/login'){
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
});

//router.afterEach(transition => {
//NProgress.done();
//});

let vm = new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App),
  beforeCreate(){
    let cfg = this.$Config.getConfig();
    this.$store.commit('setApi', (cfg.base));
  }
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js